import { Icon } from "@chakra-ui/react"
import { Position } from "@perp/sdk-curie"
import { Stats } from "component/Stats"
import { RiSkull2Line } from "react-icons/ri"

import { usePositionWithRatioStrings } from "../../../position/hook/usePositionWithRatioStrings"

interface Props {
    position: Position
    ratio?: number
}

const DECIMAL_SIX_STR = "0.000000"
const isCloseToZero = (value: string) => {
    return value.startsWith(DECIMAL_SIX_STR) || value.startsWith(`-${DECIMAL_SIX_STR}`)
}
export function MakerPositionPnl({ position, ratio }: Props) {
    const { unrealizedPnlStr, unrealizedPnl } = usePositionWithRatioStrings(position, ratio)
    return (
        <Stats
            icon={<Icon color="red.300" as={RiSkull2Line} />}
            label={"Impermanent Loss"}
            helper="Unrealized PnL from your impermanent position"
            number={
                isCloseToZero(unrealizedPnlStr) || unrealizedPnl === undefined
                    ? "≈0"
                    : "-$" + unrealizedPnl.toFixed(1).substring(1)
            }
            showTooltip={true}
            size="xl"
        />
    )
}
